export enum BadgeSize {
  Sm,
  Lg
}
